export default "__VITE_ASSET__56a0b8b6__"